import React, { useState } from "react";
import styles from "./SustainabilityCustomManufacturing.module.scss";
import LogoWithImage from "./LogoWithImage";
import ContactUsFormModal from "../ContactUsFormModal/ContactUsFormModal";
import { getCDNImageUrl } from "@/utils/Common";

const sustainabilityCards = [
  {
    title: "Sewage Treatment Plant",
    description: "~200 kilolitres of water per month is recycled",
  },
  {
    title: "Waste Recycle Plant",
    description: "~360 kilolitres of water per month is recycled",
  },
  {
    title: "Bio-mass Boiler Project",
    description:
      "23% reduction in carbon emissions compared to usage of fossil fuel",
  },
  {
    title: "Electricity Optimization Project",
    description: "16% reduction in CO2 emissions compared to previous years",
  },
  {
    title: "Zero Water Load",
    description: "8,500MT of 10,000MT runs on Zero Water Load",
  },
  {
    title: "Waste to Energy Project",
    description: "15MT waste converted into energy",
  },
];

const SustainabilityCard = ({ sustainability }) => {
  return (
    <div className={styles.sustainabilityCard}>
      <div className={styles.title}>{sustainability.title}</div>
      <div className={styles.description}>{sustainability.description}</div>
    </div>
  );
};

function SustainabilityCustomManufacturing() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  return (
    <div className={styles.sustainabilityCustomManufacturing}>
      <ContactUsFormModal
        open={isContactModalOpen}
        onClose={() => setIsContactModalOpen(false)}
      />
      {/* Text Container */}

      <div className={styles.textContainer}>
        {/* Big Heading */}
        <h2>Sustainability</h2>
        {/* Description */}
        <p>
          We are committed to responsible practices. Our customers benefit from
          ethical sourcing, reduced waste, and transparent supply chains that
          reflect shared values.
        </p>
        {/* Get in touch button */}
        <button
          onClick={() => setIsContactModalOpen(true)}
          className={styles.getInTouchButton}
        >
          Get in touch
        </button>
      </div>
      {/* Cards and Images Container */}
      <div className={styles.cardsAndImagesContainer}>
        {/* Sustainability Cards */}
        <div className={styles.row}>
          <SustainabilityCard sustainability={sustainabilityCards[0]} />
          <SustainabilityCard sustainability={sustainabilityCards[1]} />
        </div>
        <div className={styles.row}>
          <SustainabilityCard sustainability={sustainabilityCards[2]} />
          <SustainabilityCard sustainability={sustainabilityCards[3]} />
        </div>
        <div className={styles.row}>
          <SustainabilityCard sustainability={sustainabilityCards[4]} />
          <SustainabilityCard sustainability={sustainabilityCards[5]} />
        </div>
        {/* Images Container */}
        <div className={styles.imagesContainer}>
          {/* Desktop Layout */}
          <div className={styles.imagesRow}>
            <LogoWithImage src={getCDNImageUrl("cdp.webp")} alt="CDP Logo" />
            <LogoWithImage
              src={getCDNImageUrl("ecovadis.webp")}
              alt="ecovadis Logo"
            />
            <LogoWithImage
              src={getCDNImageUrl("togetherforsustainability.webp")}
              alt="Together For Sustainability Logo"
            />
            <LogoWithImage
              src={getCDNImageUrl("sedex.webp")}
              alt="sedex Logo"
              height={70}
              width={70}
            />
          </div>

          {/* Mobile Layout */}
          <div className={styles.imagesMobile}>
            <div className={styles.mobileRow}>
              <LogoWithImage src={getCDNImageUrl("cdp.webp")} alt="CDP Logo" />
              <LogoWithImage
                src={getCDNImageUrl("ecovadis.webp")}
                alt="ecovadis Logo"
              />
            </div>
            <div className={styles.mobileRow}>
              <LogoWithImage
                src={getCDNImageUrl("togetherforsustainability.webp")}
                alt="Together For Sustainability Logo"
              />
              <LogoWithImage
                src={getCDNImageUrl("sedex.webp")}
                alt="sedex Logo"
                height={70}
                width={70}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SustainabilityCustomManufacturing;
